module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image",
    attrs: {
      "id": "ch05"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "550",
      "src": "images/ch05.jpg",
      "width": "334"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLONEL")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENHALIGAN WAS SITTING, AS USUAL,")]), _vm._v(" behind his desk. For a man who took every opportunity available to talk about how he had died fighting for his country, he had always been strangely silent about his lack of legs. He wore a plush red army jacket with shiny gold buttons and ornate epaulets on his broad shoulders. Thick black sideburns framed his permanently frowning face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the wall behind his desk was a large painting of him, wearing exactly the same clothes while sitting on a horse, looking every bit as stern and serious as he looked now as Lapsewood entered the room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Take a seat,” he barked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._v("Lapsewood sat down in front of the huge desk. Like everything in the Bureau, it had been finished to look as real as a fine oak desk from the physical world. The only difference was that Colonel Penhaligan was able to lean his elbows on it without their passing straight through.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How long have you been with us, Lapsewood?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“At the Bureau? Twenty years this December, sir. I started as a clerk in the Central Records Library, then was transferred to the Dispatch Department ten years ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So you were ghost-born in 1864,” said Colonel Penhaligan. He jotted down the date, then said, “1792.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry?” Lapsewood felt unsure how to respond to this.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s my date. I’ll be celebrating my centenary in a few years’ time. Started as a Prowler, then worked my way up to the head of the department. Few ghosts make it that long, and do you know why that is?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They date themselves. They lose touch. They become irrelevant. As ghosts, we don’t age, but as time goes on, many find it difficult to deal with the changing nature of the world. Take the steam train.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry, sir. I’m not following. You want me to take a steam train?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, of course I don’t want you to take a steam train. You think I’ve asked you to come up to my office in order to ask you to take a steam train? What’s wrong with you, man? I’m talking about myself. The idea of being propelled across "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _vm._v("the country on a huge metal beast on tracks at unnatural speeds would have filled me with wonder and delight as a child, like being told that I could fly like a bird through the sky. It would have been a fancy. But now? I have managed to adjust to the idea. With new technologies come new ways for the living to die, and, here in the Dispatch Department, we need to adapt to these changes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s not just keeping our records up to date, you know. The world is full of Rogue ghosts who seem to think they don’t need Polter-licenses to mess about with things in the physical world or Opacity Permission forms to be seen. It’s a real problem, Lapsewood.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I thought Enforcement dealt with the Rogues,” said Lapsewood.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hardknuckle’s bunch of half-baked Enforcers can no more deal with the Rogue problem than a horse can knit.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, sir,” replied Lapsewood, trying to keep up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s my Prowlers who gather the intelligence that allows us to keep on top of the problem. Like that man Vidocq. Excellent Prowler. Shame about his being, you know …” Colonel Penhaligan lowered his voice and said, “French. But I haven’t asked you here to talk about him. We’re here to look at the options ahead of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Options, sir?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Colonel Penhaligan sighed, clearly annoyed at having to spell it out. “You’re behind in your paperwork, Lapsewood. Woefully behind.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know, but—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _vm._v("“Save it,” said the colonel, raising a hand. “I’m afraid I’ve heard it all before. Tell me, Lapsewood, how did you die?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know, sir. I fell ill and never recovered.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Age?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thirty-two, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I see. And you never heard the Knocking?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course not,” said Lapsewood, shocked to be asked such a thing. “Only Rogue ghosts hear the Knocking and ignore it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So you have unfinished business?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, but I don’t know what.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Perhaps you should consider applying for a research license, venture to the physical world, and finish that business of yours.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lapsewood’s head was spinning. “But, sir, I don’t want to. I like my job here at the Bureau. I like my work.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And yet you’re getting behind. Why is that, Lapsewood? There’s no plague at the moment, no exceptionally bloody wars. Granted, mortality rates are on the rise due to the ever-increasing population, but this has been happening for years. You have fallen behind because that’s what happens. You did well to last so long. But it’s time for someone new. I was thinking it might be a good opportunity to give Mr. Grunt a chance. He seems ever so eager to please, and he’s rather young—in ghost terms, of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Grunt, in my office, sir?” Lapsewood was sickened by the idea.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _vm._v("“Exactly.” Colonel Penhaligan rapped his knuckles on the desk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But please, I’m not ready,” Lapsewood protested. “I want to be like you and work here as long as possible.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, but I’ve got breeding. Good stock. It’s the same as horses. Breed two thoroughbreds and you’ll have a thoroughbred; breed donkeys and guess what you’ll get?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not a donkey, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What were your parents, Lapsewood?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My father was a shopkeeper, and my mother was a maid, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Exactly, Lapsewood. Donkeys, the both of them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Please, sir, I’m begging you. I’ll do anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Colonel Penhaligan sighed. “I like you, Lapsewood. You’ve got ambition. You’ve got gumption. You want to prove me wrong about this whole donkey business, don’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Very well. I’ll give you a chance to prove yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You mean, I can go back to my office, sir?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good grief, man, no. I don’t want you in my department. Luckily for you, General Colt from Housing has been badgering me for someone to go help him out with some sort of problem he’s got.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Housing, sir?” Lapsewood had never even heard of a Housing Department.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Haunted houses. It’s one of the smaller departments,” said Penhaligan. “I don’t know the ins and outs of it, and I "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _vm._v("have no interest in finding out. If you ask me, General Colt is about as useful as a blunt bayonet. I’d have him replaced if I had my way, but I did say I’d send him someone.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“To do what?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know,” said Colonel Penhaligan, with an exasperated sigh. “Dispatch has plenty enough to keep me occupied without any need to meddle in other people’s business. Run along now before I change my mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, sir. Thank you, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the other side of the door, Lapsewood was relieved to find Monsieur Vidocq gone. Yet, even in his absence, the suave Frenchman was clearly holding a greater percentage of Alice’s attention than Lapsewood could manage while he was present.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How was it, then?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m being transferred to Housing,” replied Lapsewood gloomily.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, General Colt’s department.” She leaned forward conspiratorially. “He’s a lazy one, by all accounts. I know I grumble about old Colonel Grumps in there, but at least he takes an interest in the work. As I hear it, Mrs. Pringle has to do everything, while old Colt spends all his time on the golf course. I wonder what Colt wants "), _c('em', [_vm._v("you")]), _vm._v(" for.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lapsewood didn’t like the way she said that, as though she could never imagine anyone in his right mind ever wanting him for anything.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“At least you won’t have to come up here and see Grumps anymore,” said Alice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _vm._v("Lapsewood hadn’t thought of that. There would be no more excuses to come see Alice. He searched her face for some sign of sadness but found none.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, listen to me,” she said. “Prattling on, wasting your time, when you need me to tell you where to go.” She pulled out a large book from her desk drawer that listed all the departments in the Bureau. “Housing … ah, here we are,” she said. “Room 412 on the fortieth floor.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you,” said Lapsewood, cursing his cowardly heart more than ever. He walked solemnly to the door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you really going to leave like that?” asked Alice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The words stopped Lapsewood in his tracks. He felt as though his dead heart had started beating again. Alice couldn’t bear the thought of him walking out any more than he could. There was more to be said. There were feelings to reveal, sonnets to be penned, songs to be sung, declarations to be made. Finally he could admit his feelings, and Alice Biggins would reveal hers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, Alice,” he said, his newfound confidence deepening his voice. “I’m not going to leave like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She laughed. Such a beautiful laugh. As light and carefree as the song of a lark.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I did wonder,” she said. “The Paternoster Pipe will be much quicker.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All the joy vanished. All Lapsewood’s dreams, all his hopes, seeped away like water down a drain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I prefer to walk,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He opened the door and left.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c152c9f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch05.vue
// module id = 93
// module chunks = 0